import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuildings_buildingIdEnpiInputs = z.any()
export type TagsGetBuildings_buildingIdEnpiInputs = z.infer<typeof tagsGetBuildings_buildingIdEnpiInputs>

export const paramsGetBuildings_buildingIdEnpiInputs = z.object({ "buildingId": z.string().uuid() })
export type ParamsGetBuildings_buildingIdEnpiInputs = z.infer<typeof paramsGetBuildings_buildingIdEnpiInputs>

export const querystringGetBuildings_buildingIdEnpiInputs = z.object({ "periodFrom": z.string().date(), "periodTo": z.string().date() })
export type QuerystringGetBuildings_buildingIdEnpiInputs = z.infer<typeof querystringGetBuildings_buildingIdEnpiInputs>

export const responseGetBuildings_buildingIdEnpiInputs = z.object({ "payload": z.object({ "inputs": z.array(z.object({ "key": z.string(), "label": z.string(), "unit": z.string(), "value": z.union([z.number(), z.null()]), "source": z.union([z.literal("card"), z.literal("recorded"), z.literal("manual")]), "warnings": z.array(z.string()) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetBuildings_buildingIdEnpiInputs = z.infer<typeof responseGetBuildings_buildingIdEnpiInputs>

interface IGetBuildings_buildingIdEnpiInputs extends BaseMethodType {
  tags: TagsGetBuildings_buildingIdEnpiInputs,
  params: ParamsGetBuildings_buildingIdEnpiInputs,
  querystring: QuerystringGetBuildings_buildingIdEnpiInputs,
  response: ResponseGetBuildings_buildingIdEnpiInputs
}
export const URL = '/buildings/:buildingId/enpi/inputs'
export const validation = {
  get: {
    tags: tagsGetBuildings_buildingIdEnpiInputs,
    params: paramsGetBuildings_buildingIdEnpiInputs,
    querystring: querystringGetBuildings_buildingIdEnpiInputs,
    response: responseGetBuildings_buildingIdEnpiInputs
  }
}
export interface Buildings_buildingIdEnpiInputs extends BaseRouteType {
  get: IGetBuildings_buildingIdEnpiInputs
}